module.exports = __webpack_public_path__ + "static/entryway-3f3fee99bf29db49bcde192752aa2040.jpg";